import { addNotification as notify } from "reapop";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/of";
import "rxjs/add/operator/catch";
import "rxjs/add/operator/map";
import "rxjs/add/operator/mergeMap";
import "rxjs/add/operator/switchMap";
import { concat as concat$ } from "rxjs/observable/concat";
import * as DTOS from "../FeralScan.dtos";
import { ADMIN_ADD_USER_TO_GRP_REQUEST, ADMIN_USER_GRP_REQUEST, ADMIN_APRROVE_USER_4_GRP_REQUEST, AdminAction, ADMIN_DEL_USER_FROM_GRP_REQUEST, ADMIN_EDIT_USER_GRP_REQUEST, ADMIN_EDIT_USER_REQUEST, ADMIN_SEARCH_PLOTS_REQUEST, ADMIN_SEARCH_USERS_REQUEST, ADMIN_SEARCH_USER_GRP_REQUEST, approveUserForUserGroupSuccess, deleteUserFromUserGroupSuccess, editUserGroupsSuccess, editUserSuccess, inviteUserToUserGroupSuccess, searchPlotsSuccess, searchUserGroupsSuccess, searchUsersSuccess, setAdminUserUserGroupSuccess, ISearchUsersRequest, ADMIN_GET_SINGLE_USER_REQUEST, IGetSingleUserRequest, getSingleUserSuccess, ISearchPlotsRequest, ADMIN_BATCH_IMPORT_REQUEST, IBatchAdminImportRequest, ADMIN_SEARCH_USER_ROLES_REQUEST, ISearchUserRolesRequest, searchUserRolesSuccess, batchImportSuccess, batchImportFail, ADMIN_SEARCH_FILES_REQUEST, ISearchFilesRequest, searchFilesSuccess, ADMIN_GET_PLOT_METAINFO_REQUEST, IGetPlotMetaInfoRequest, getPlotMetaInfoSuccess } from "../actions/admin.actions";
import * as ErrorHandler from "../common/errorHandler";
import * as NotificationsActionCreators from "../common/notification";
import { serviceApi } from "../services/template.service";
import { searchTemplatesSuccess, ISearchTemplatesRequest, SEARCH_TEMPLATES_REQUEST } from "../actions/template.actions";


export const searchTemplates = action$ =>
    action$
        .ofType(SEARCH_TEMPLATES_REQUEST)
        .mergeMap((action: ISearchTemplatesRequest) =>
            serviceApi
                .getTemplates(action.templateId, action.searchText)
                .mergeMap(response => {
                    return concat$(
                        Observable.of(searchTemplatesSuccess(response))
                    )
                })
                .catch((error) => ErrorHandler.FireErrorActions(error))
        );
